export default __webpack_public_path__ + "static/training-bg-960284fdaaf004204f7dee156652ca25.jpg";